import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationBankVerificationResponseCodes = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
